import { render, staticRenderFns } from "./StatBadge.vue?vue&type=template&id=37f1f188&"
import script from "./StatBadge.vue?vue&type=script&lang=js&"
export * from "./StatBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports